export const booksOfAccountsGeneralLedgerColumns = [
  { key: 'transactedAt', text: `Date`, width: '8%' },
  { key: 'accountCode', text: `Account Code`, width: '4%' },
  { key: 'account', text: `Account`, width: '15%' },
  { key: 'reference', text: `Reference`, width: '10%' },
  { key: 'debit', text: `Sum of Debits`, width: '10%' },
  { key: 'credit', text: `Sum of Credit`, width: '10%' },
  { key: 'options', text: ``, width: '10%' }
];
